export default __webpack_public_path__ + "static/media/language.a73a447e.svg";